export enum TermsAndConditionsKey {
  NO_PTRAB = 'internal_no_ptrab_web',
  PTRAB = 'internal_ptrab_web',
  EXTERNAL = 'external_web'
}
